<template>
    <div>
        <div class="card-header bg-primary text-white mb-3">
            <page-title :title="$t('applicationSettings.title')" :showTitle="true"></page-title>
        </div>

        <div>
            <button type="button" class="btn btn-info" @click.stop="getAppsettingsData">appsettings.json data</button>
        </div>

        <div class="card col-12 mx-auto mt-2 px-0">
            <div class="card-header">
                <h5>{{ $t('applicationSettings.userSettings.title') }}</h5>
            </div>
            <div class="loader" v-if="appUserSettingsLoading"></div>
            <div v-else class="p-3">
                <!--{{appUserSettingsModel}}-->
                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'registrationDefaultUserRole' + _uid">{{$t('applicationSettings.userSettings.registrationDefaultUserRole')}}</label>
                        <dynamic-dropdown :apiUrl="`/api/roles/dropdownModels`"
                                          v-model="appUserSettingsModel.defaultUserRoleId"
                                          :id="'registrationDefaultUserRole' + _uid"
                                          :name="'registrationDefaultUserRole' + _uid"
                                          :fieldName="$t('applicationSettings.userSettings.registrationDefaultUserRole')"
                                          :filter="'contains'"
                                          :clear-button="true"
                                          :autoWidth="true"
                                          :height="400"
                                          :hasStringId="true"
                                          aria-describedby="registrationDefaultUserRoleHelpBlock"></dynamic-dropdown>
                        <small id="registrationDefaultUserRoleHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.userSettings.help.registrationDefaultUserRole') }}</small>
                    </div>
                </div>
                <div class="btn-group" role="group" aria-label="Application user settings">
                    <button type="button"
                            class="btn btn-success"
                            @click.stop="saveAppUserSettings">
                        <i class="fas fa-save mr-2"></i>
                        {{ $t('buttons.save.btnText')}}
                    </button>
                </div>
            </div>
        </div>

        <div class="card col-12 mx-auto mt-2 px-0">
            <div class="card-header">
                <h5>{{ $t('applicationSettings.eventSettings.title') }}</h5>
            </div>
            <div class="loader" v-if="appEventSettingsLoading"></div>
            <div v-else class="p-3">
                <!--{{appEventSettingsModel}}-->
                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'createNewFormOnAddToEvent' + _uid">
                            {{$t('applicationSettings.eventSettings.createNewFormOnAddToEvent')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.createNewFormOnAddToEvent"
                                :id="'createNewFormOnAddToEvent' + _uid"
                                aria-describedby="createNewFormOnAddToEventHelpBlock">
                        </toggle>
                        <small id="createNewFormOnAddToEventHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.createNewFormOnAddToEvent') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'checkEventTimeRangeOnFormAddToEvent' + _uid">
                            {{$t('applicationSettings.eventSettings.checkEventTimeRangeOnFormAddToEvent')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.checkEventTimeRangeOnFormAddToEvent"
                                :id="'checkEventTimeRangeOnFormAddToEvent' + _uid"
                                aria-describedby="checkEventTimeRangeOnFormAddToEventHelpBlock">
                        </toggle>
                        <small id="checkEventTimeRangeOnFormAddToEventHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.checkEventTimeRangeOnFormAddToEvent') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'checkEventSubscriptionTimeRangeOnFormAddToEvent' + _uid">
                            {{$t('applicationSettings.eventSettings.checkEventSubscriptionTimeRangeOnFormAddToEvent')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.checkEventSubscriptionTimeRangeOnFormAddToEvent"
                                :id="'checkEventSubscriptionTimeRangeOnFormAddToEvent' + _uid"
                                aria-describedby="checkEventSubscriptionTimeRangeOnFormAddToEventHelpBlock">
                        </toggle>
                        <small id="checkEventSubscriptionTimeRangeOnFormAddToEventHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.checkEventSubscriptionTimeRangeOnFormAddToEvent') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'filterParticipationRelationTypeByParticipationType' + _uid">{{$t('applicationSettings.eventSettings.filterParticipationRelationTypeByParticipationType')}}</label>
                        <toggle v-model="appEventSettingsModel.filterParticipationRelationTypeByParticipationType"
                                :id="'filterParticipationRelationTypeByParticipationType' + _uid"
                                aria-describedby="filterParticipationRelationTypeByParticipationTypeHelpBlock">
                        </toggle>
                        <small id="filterParticipationRelationTypeByParticipationTypeHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.filterParticipationRelationTypeByParticipationType') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'filterReasonForAdmissionByParticipationType' + _uid">
                            {{$t('applicationSettings.eventSettings.filterReasonForAdmissionByParticipationType')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.filterReasonForAdmissionByParticipationType"
                                :id="'filterReasonForAdmissionByParticipationType' + _uid"
                                aria-describedby="filterReasonForAdmissionByParticipationTypeHelpBlock">
                        </toggle>
                        <small id="filterReasonForAdmissionByParticipationTypeHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.filterReasonForAdmissionByParticipationType') }}
                        </small>
                    </div>

                    <!--<div class="form-group col-sm-12 col-md-12 col-lg-6">
            <label class="font-weight-bold" :for="'moodleEventNameComposingPattern' + _uid">
                {{$t('applicationSettings.eventSettings.moodleEventNameComposingPattern')}}
            </label>
            <input class="form-control" type="text" v-model="appEventSettingsModel.moodleEventNameComposingPattern"
                   :id="'moodleEventNameComposingPattern' + _uid"
                   aria-describedby="moodleEventNameComposingPatternHelpBlock" />
            <small id="moodleEventNameComposingPatternHelpBlock" class="form-text text-muted">
                {{ $t('applicationSettings.eventSettings.help.moodleEventNameComposingPattern') }}
            </small>
        </div>-->
                </div>

                <hr />

                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'skipRankingQuotaEvaluation' + _uid">
                            {{$t('applicationSettings.eventSettings.skipRankingQuotaEvaluation')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.skipRankingQuotaEvaluation"
                                :id="'skipRankingQuotaEvaluation' + _uid"
                                aria-describedby="skipRankingQuotaEvaluationHelpBlock">
                        </toggle>
                        <small id="skipRankingQuotaEvaluationHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.skipRankingQuotaEvaluation') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'rankWithNoneQuotes' + _uid">
                            {{$t('applicationSettings.eventSettings.rankWithNoneQuotes')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.rankWithNoneQuotes"
                                :id="'rankWithNoneQuotes' + _uid"
                                aria-describedby="rankWithNoneQuotesHelpBlock">
                        </toggle>
                        <small id="rankWithNoneQuotesHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.rankWithNoneQuotes') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'rerankDropoutFromQuota' + _uid">
                            {{$t('applicationSettings.eventSettings.rerankDropoutFromQuota')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.rerankDropoutFromQuota"
                                :id="'rerankDropoutFromQuota' + _uid"
                                aria-describedby="rerankDropoutFromQuotaHelpBlock">
                        </toggle>
                        <small id="rerankDropoutFromQuotaHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.rerankDropoutFromQuota') }}
                        </small>
                    </div>
                </div>

                <hr />
                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'createInstitutionOnParticipantsImport' + _uid">
                            {{$t('applicationSettings.eventSettings.createInstitutionOnParticipantsImport')}}
                        </label>
                        <toggle v-model="appEventSettingsModel.createInstitutionOnParticipantsImport"
                                :id="'createInstitutionOnParticipantsImport' + _uid"
                                aria-describedby="createInstitutionOnParticipantsImportHelpBlock">
                        </toggle>
                        <small id="createInstitutionOnParticipantsImportHelpBlock"
                               class="form-text text-muted">
                            {{ $t('applicationSettings.eventSettings.help.createInstitutionOnParticipantsImport') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'accommodationRequestDaterangeMinLimitToFieldRelation' + _uid">{{$t('applicationSettings.eventSettings.accommodationRequestDaterangeMinLimitToFieldRelation')}}</label>
                        <kendo-dropdownlist :id="'accommodationRequestDaterangeMinLimitToFieldRelation' + _uid"
                                            v-model="appEventSettingsModel.accommodationRequestDaterangeMinLimitToFieldRelation"
                                            :data-source="accommodationRequestDaterangeMinLimitToFieldRelationSource"
                                            :data-text-field="'text'"
                                            :data-value-field="'value'"
                                            :name="'accommodationRequestDaterangeMinLimitToFieldRelation' + _uid"
                                            clear-button
                                            style="width: 100%;">
                        </kendo-dropdownlist>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'accommodationRequestDaterangeMaxLimitToFieldRelation' + _uid">{{$t('applicationSettings.eventSettings.accommodationRequestDaterangeMaxLimitToFieldRelation')}}</label>
                        <kendo-dropdownlist :id="'accommodationRequestDaterangeMaxLimitToFieldRelation' + _uid"
                                            v-model="appEventSettingsModel.accommodationRequestDaterangeMaxLimitToFieldRelation"
                                            :data-source="accommodationRequestDaterangeMaxLimitToFieldRelationSource"
                                            :data-text-field="'text'"
                                            :data-value-field="'value'"
                                            :name="'accommodationRequestDaterangeMaxLimitToFieldRelation' + _uid"
                                            clear-button
                                            style="width: 100%;">
                        </kendo-dropdownlist>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6"
                         v-if="accommodationRequestDaterangeLimitToEventsSkipSource">
                        <label class="font-weight-bold"
                               :for="'accommodationRequestDaterangeLimitToEventsSkip' + _uid">{{$t('applicationSettings.eventSettings.accommodationRequestDaterangeLimitToEventsSkip')}}</label>
                        <kendo-multiselect v-model="appEventSettingsModel.accommodationRequestDaterangeLimitToEventsSkip"
                                           :data-source="accommodationRequestDaterangeLimitToEventsSkipSource"
                                           :data-text-field="'text'"
                                           :data-value-field="'id'"
                                           :data-placeholder="$t('choose')"
                                           :name="'accommodationRequestDaterangeLimitToEventsSkip' + _uid"
                                           :id="'accommodationRequestDaterangeLimitToEventsSkip' + _uid"
                                           auto-width
                                           clear-button
                                           :height="600"
                                           style="width: 100%;">
                        </kendo-multiselect>

                    </div>
                </div>


                <div class="btn-group" role="group" aria-label="Application event settings">
                    <button type="button"
                            class="btn btn-success"
                            @click.stop="saveAppEventSettings">
                        <i class="fas fa-save mr-2"></i>
                        {{ $t('buttons.save.btnText')}}
                    </button>
                </div>
            </div>
        </div>

        <div class="card col-12 mx-auto mt-2 px-0">
            <div class="card-header">
                <h5>{{ $t('applicationSettings.formSettings.title') }}</h5>
            </div>
            <div class="loader" v-if="appFormSettingsLoading"></div>
            <div v-else class="p-3">
                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label
                            class="font-weight-bold"
                            :for="'formTypesWithAnonymousFillingAllowed' + _uid"
                        >
                               {{ $t('applicationSettings.formSettings.formTypesWithAnonymousFillingAllowed') }}
                        </label>
                        <NomenclatureMultiDropdown
                            v-model="appFormSettingsModel.formTypesWithAnonymousFillingAllowed"
                            :loadByParentSort="true"
                            :parentSort="formTypeSort"
                            :id="'formTypesWithAnonymousFillingAllowed' + _uid"
                            :name="'formTypesWithAnonymousFillingAllowed' + _uid"
                            :fieldName="$t('applicationSettings.formSettings.formTypesWithAnonymousFillingAllowed')"
                        />

                    </div>
                </div>
                <div class="btn-group" role="group" aria-label="Application form settings">
                    <button type="button"
                            class="btn btn-success"
                            @click.stop="saveAppFormSettings">
                        <i class="fas fa-save mr-2"></i>
                        {{ $t('buttons.save.btnText')}}
                    </button>
                </div>
            </div>
        </div>
        <div class="card col-12 mx-auto mt-2 px-0">
            <div class="card-header">
                <h5>{{ $t('applicationSettings.isupoSettings.title') }}</h5>
            </div>
            <div class="loader" v-if="appIsupoSettingsLoading"></div>
            <div v-else class="p-3">
                <!--{{appIsupoSettingsModel}}-->
                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'schema' + _uid">{{$t('applicationSettings.isupoSettings.schema')}}</label>
                        <kendo-dropdownlist :id="'schema' + _uid"
                                            v-model="appIsupoSettingsModel.schema"
                                            :data-source="schemaSource"
                                            :data-text-field="'text'"
                                            :data-value-field="'value'"
                                            :name="'schema' + _uid"
                                            style="width: 100%;"></kendo-dropdownlist>
                        <small id="schemaHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.isupoSettings.help.schema') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'hostName' + _uid">{{$t('applicationSettings.isupoSettings.hostName')}}
                        </label>
                        <input class="form-control"
                               type="text"
                               v-model="appIsupoSettingsModel.hostName"
                               :id="'hostName' + _uid"
                               aria-describedby="hostNameHelpBlock" />
                        <small id="hostNameHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.isupoSettings.help.hostName') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'migrateParticipantsInSingleStatement' + _uid">{{$t('applicationSettings.isupoSettings.migrateParticipantsInSingleStatement')}}
                        </label>
                        <toggle v-model="appIsupoSettingsModel.migrateParticipantsInSingleStatement"
                                :id="'migrateParticipantsInSingleStatement' + _uid"
                                aria-describedby="migrateParticipantsInSingleStatementHelpBlock">
                        </toggle>
                        <small id="migrateParticipantsInSingleStatementHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.isupoSettings.help.migrateParticipantsInSingleStatement') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'migrateParticipantsBatchSize' + _uid">{{$t('applicationSettings.isupoSettings.migrateParticipantsBatchSize')}}
                        </label>
                        <input class="form-control"
                               type="number"
                               min="10"
                               max="1000"
                               step="10"
                               v-model="appIsupoSettingsModel.migrateParticipantsBatchSize"
                               :id="'migrateParticipantsBatchSize' + _uid"
                               aria-describedby="migrateParticipantsBatchSizeHelpBlock" />
                        <small id="migrateParticipantsBatchSizeHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.isupoSettings.help.migrateParticipantsBatchSize') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'showDraftReports' + _uid">{{$t('applicationSettings.isupoSettings.showDraftReports')}}
                        </label>
                        <toggle v-model="appIsupoSettingsModel.showDraftReports"
                                :id="'showDraftReports' + _uid"
                                aria-describedby="showDraftReportsHelpBlock">
                        </toggle>
                        <small id="showDraftReportsHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.isupoSettings.help.showDraftReports') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'loadLocalizationFromDb' + _uid">{{$t('applicationSettings.isupoSettings.loadLocalizationFromDb')}}
                        </label>
                        <toggle v-model="appIsupoSettingsModel.loadLocalizationFromDb"
                                :id="'loadLocalizationFromDb' + _uid"
                                aria-describedby="loadLocalizationFromDbHelpBlock">
                        </toggle>
                        <small id="loadLocalizationFromDbHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.isupoSettings.help.loadLocalizationFromDb') }}
                        </small>
                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-6">
                        <label class="font-weight-bold"
                               :for="'loadLocalizationFromDb' + _uid">{{$t('applicationSettings.isupoSettings.includeMergedProfiles')}}
                        </label>
                        <toggle v-model="appIsupoSettingsModel.includeMergedProfiles"
                                :id="'includeMergedProfiles' + _uid"
                                aria-describedby="includeMergedProfilesHelpBlock">
                        </toggle>
                        <small id="includeMergedProfilesHelpBlock"
                               class="form-text text-muted">{{ $t('applicationSettings.isupoSettings.help.includeMergedProfiles') }}
                        </small>
                    </div>
                </div>
                <div class="btn-group" role="group" aria-label="Application isupo settings">
                    <button type="button"
                            class="btn btn-success"
                            @click.stop="saveAppIsupoSettings">
                        <i class="fas fa-save mr-2"></i>
                        {{ $t('buttons.save.btnText')}}
                    </button>
                </div>
            </div>
        </div>

        <div class="card col-12 mx-auto mt-2 px-0">
            <div class="card-header">
                <h5>{{ $t('applicationSettings.signingSettings.title') }}</h5>
            </div>
            <div class="loader" v-if="appSigningSettingsLoading"></div>
            <div v-show="!appSigningSettingsLoading" class="p-3">
                <app-signing-settings-editor v-model="appSigningSettingsModel" />
                <div class="btn-group" role="group" aria-label="Application isupo settings">
                    <button type="button"
                            class="btn btn-success"
                            @click.stop="saveAppSigningSettings">
                        <i class="fas fa-save mr-2"></i>
                        {{ $t('buttons.save.btnText')}}
                    </button>
                </div>
            </div>
        </div>

        <JsonFormatter v-model="appSettinsData" :show.sync="showAppSettingsDetails"
            :titleKey="'buttons.details.btnText'"
            @onClose="onAppSettingsDetailsClose">
        </JsonFormatter>
    </div>
</template>

<script>
    import DynamicDropdown from '@/components/dropdown/DynamicDropdown';
    import NomenclatureMultiDropdown from '@/components/dropdown/MultiSelect';
    import JsonFormatter from '@/components/common/json.formatter.modal.vue';
    import PageTitle from '@/components/common/PageTitle';
    import Toggle from '@/components/toggle/Toggle';
    import AppSigningSettingsEditor from '@/components/administration/AppSigningSettingsEditor';
    import {
        AppUserSettings,
        AppEventSettings,
        AppIsupoSettings,
        AppFormSettings,
    } from '@/models/models';
    import { NomenclatureParentBySort } from "../../models/enums";
    import { mapGetters } from 'vuex';

    export default {
        components: {
            DynamicDropdown,
            NomenclatureMultiDropdown,
            PageTitle,
            Toggle,
            JsonFormatter,
            AppSigningSettingsEditor
        },
        data() {
            return {
                appUserSettingsLoading: false,
                appUserSettingsModel: "",
                appEventSettingsLoading: false,
                appEventSettingsModel: "",
                appIsupoSettingsLoading: false,
                appIsupoSettingsModel: "",
                appSigningSettingsLoading: false,
                appSigningSettingsModel: {},
                appFormSettingsLoading: false,
                appFormSettingsModel: "",
                schemaSource: [
                    { value: "http", text: "http" },
                    { value: "https", text: "https" },
                ],
                accommodationRequestDaterangeMinLimitToFieldRelationSource: [
                    { value: "Event_start", text: "Event_start" },
                    { value: "Event_Stay_From", text: "Event_Stay_From" },
                ],
                accommodationRequestDaterangeMaxLimitToFieldRelationSource: [
                    { value: "Event_end", text: "Event_end" },
                    { value: "Event_Stay_To", text: "Event_Stay_To" },
                ],
                accommodationRequestDaterangeLimitToEventsSkipSource: null,
                appSettinsData: '',
                showAppSettingsDetails: false,
                formTypeSort: NomenclatureParentBySort.FormType,
            };
        },
        computed: {
            ...mapGetters(['claims']),
            hasSigningAdministrationReadPermission() {
                return this.claims.signingAdministration.read;
            },
            hasSigningAdministrationUpdatePermission() {
                return this.claims.signingAdministration.update;
            }

        },
        mounted() {
            this.loadAppUserSettings();
            this.loadAppEventSettings();
            this.loadAppFormSettings();
            this.loadAppIsupoSettings();
            this.loadEvents();
            this.loadAppSigningSettings();
        },

        methods: {
            loadAppUserSettings() {
                this.appUserSettingsLoading = true;

                this.$api.appSettings
                    .getAppUserSettings()
                    .then((response) => {
                        if (response.data) {
                            this.appUserSettingsModel = new AppUserSettings(
                                response.data
                            );
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => (this.appUserSettingsLoading = false));
            },
            saveAppUserSettings() {
                this.appUserSettingsLoading = true;

                this.$api.appSettings
                    .saveAppUserSettings(this.appUserSettingsModel)
                    .then((response) => {
                        this.saveSuccessNotification(response);
                    })
                    .catch((error) => {
                        this.saveErrorrNotification(error);
                    })
                    .then(() => (this.appUserSettingsLoading = false));
            },
            loadAppEventSettings() {
                this.appEventSettingsLoading = true;

                this.$api.appSettings
                    .getAppEventSettings()
                    .then((response) => {
                        if (response.data) {
                            this.appEventSettingsModel = new AppEventSettings(
                                response.data
                            );
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => (this.appEventSettingsLoading = false));
            },
            saveAppEventSettings() {
                this.appEventSettingsLoading = true;

                this.$api.appSettings
                    .saveAppEventSettings(this.appEventSettingsModel)
                    .then((response) => {
                        this.saveSuccessNotification(response);
                    })
                    .catch((error) => {
                        this.saveErrorrNotification(error);
                    })
                    .then(() => (this.appEventSettingsLoading = false));
            },
            loadAppFormSettings() {
                this.appFormSettingsLoading = true;

                this.$api.appSettings
                    .getAppFormSettings()
                    .then((response) => {
                        if (response.data) {
                            this.appFormSettingsModel = new AppFormSettings(
                                response.data
                            );
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => (this.appFormSettingsLoading = false));
            },
            saveAppFormSettings() {
                this.appFormSettingsLoading = true;

                this.$api.appSettings
                    .saveAppFormSettings(this.appFormSettingsModel)
                    .then((response) => {
                        this.saveSuccessNotification(response);
                    })
                    .catch((error) => {
                        this.saveErrorrNotification(error);
                    })
                    .finally(() => (this.appFormSettingsLoading = false));
            },
            loadAppIsupoSettings() {
                this.appIsupoSettingsLoading = true;

                this.$api.appSettings
                    .getAppIsupoSettings()
                    .then((response) => {
                        if (response.data) {
                            this.appIsupoSettingsModel = new AppIsupoSettings(
                                response.data
                            );
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => (this.appIsupoSettingsLoading = false));
            },
            saveAppIsupoSettings() {
                this.appIsupoSettingsLoading = true;

                this.$api.appSettings
                    .saveAppIsupoSettings(this.appIsupoSettingsModel)
                    .then((response) => {
                        this.saveSuccessNotification(response);
                    })
                    .catch((error) => {
                        this.saveErrorrNotification(error);
                    })
                    .then(() => (this.appIsupoSettingsLoading = false));
            },
            loadAppSigningSettings() {
                this.appSigningSettingsLoading = true;

                this.$api.appSettings
                    .getAppSigningSettings()
                    .then((response) => {
                        if (response.data) {
                            this.appSigningSettingsModel = response.data;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => (this.appSigningSettingsLoading = false));
            },
            saveAppSigningSettings() {
                this.appSigningSettingsLoading = true;

                this.$api.appSettings
                    .saveAppSigningSettings(this.appSigningSettingsModel)
                    .then((response) => {
                        this.saveSuccessNotification(response);
                    })
                    .catch((error) => {
                        this.saveErrorrNotification(error);
                    })
                    .then(() => (this.appSigningSettingsLoading = false));
            },
            getAppsettingsData() {
                this.$api.appSettings
                    .getAppsettingsData()
                    .then((response) => {
                        if (response.data) {
                            this.appSettinsData = response.data;
                            this.showAppSettingsDetails = true;
                        }
                    })
                    .catch((error) =>
                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        })
                    );
            },
            onAppSettingsDetailsClose() {
                this.appSettinsData = '';
                this.showAppSettingsDetails = false
            },
            loadEvents() {
                this.$http
                    .get('/api/dynamicRegisters/eventsDropdowns')
                    .then((result) => {
                        if (result.data) {
                            this.accommodationRequestDaterangeLimitToEventsSkipSource = result.data.map(x => {
                                return {
                                    id: x.id,
                                    text: `${x.id} / ${x.text}`,
                                    textEn: `${x.id} / ${x.textEn}`
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        // TODO: Toast
                    });
            },
            saveSuccessNotification(response) {
                return this.$vs.notify({
                    title: this.$t('buttons.save.btnText'),
                    text: this.$helpers.responseMessage(response),
                    color: "success",
                    time: this.$store.getters.notificationDuration,
                });
            },
            saveErrorrNotification(error) {
                return this.$vs.notify({
                    title: this.$t('buttons.save.btnText'),
                    text: this.$helpers.errorText(error),
                    color: this.$helpers.errorColor(error),
                    time: this.$store.getters.notificationDuration,
                })
            }
        },
    };
</script>

